import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import type { ApiRecord } from "@/types/api";

/** Triggers/reads broker-state synchronization — read-only import per ADR-033; never submits orders. */
export const syncService = {
  async getStatus(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.sync.status);
    return response.data;
  },
  async syncAll(): Promise<ApiRecord> {
    const response = await apiClient.post<ApiRecord>(endpoints.sync.root);
    return response.data;
  },
  async syncOrders(): Promise<ApiRecord> {
    const response = await apiClient.post<ApiRecord>(endpoints.sync.orders);
    return response.data;
  },
  async syncTrades(): Promise<ApiRecord> {
    const response = await apiClient.post<ApiRecord>(endpoints.sync.trades);
    return response.data;
  },
  async syncPositions(): Promise<ApiRecord> {
    const response = await apiClient.post<ApiRecord>(endpoints.sync.positions);
    return response.data;
  },
  async syncHoldings(): Promise<ApiRecord> {
    const response = await apiClient.post<ApiRecord>(endpoints.sync.holdings);
    return response.data;
  },
};
